import { Icon, IconButton } from '@mui/material'

import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import LoadingComponent from 'modules/Loading'

interface Props {
	isEdit: boolean
	canSave: boolean
	saving: boolean
	deleting: boolean
	onSave: () => void
	onDelete?: () => void
}

function PayphoneModalHeader({
	isEdit,
	canSave,
	saving,
	deleting,
	onSave,
	onDelete,
}: Props): JSX.Element {
	return (
		<MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
			<MDTypography variant="h4" fontWeight="medium">
				{isEdit ? 'Edit Payphone Location' : 'New Payphone Location'}
			</MDTypography>
			<MDBox display="flex" alignItems="center" gap={0.5}>
				{saving ? (
					<MDBox display="flex" alignItems="center" justifyContent="center" width={30} height={30}>
						<LoadingComponent
							type="circular_black"
							height={30}
							width={30}
							speed={0.8}
							containerStyle={{ opacity: 0.4 }}
						/>
					</MDBox>
				) : (
					<IconButton
						size="large"
						disabled={deleting || !canSave}
						onClick={onSave}
						style={{ opacity: canSave ? 1 : 0.3 }}
					>
						<Icon fontSize="inherit" color="primary">
							save
						</Icon>
					</IconButton>
				)}
				{isEdit &&
					(deleting ? (
						<MDBox display="flex" alignItems="center" justifyContent="center" width={30} height={30}>
							<LoadingComponent
								type="circular_black"
								height={30}
								width={30}
								speed={0.8}
								containerStyle={{ opacity: 0.4 }}
							/>
						</MDBox>
					) : (
						<IconButton size="large" disabled={saving} onClick={onDelete}>
							<Icon fontSize="inherit" color="error">
								delete_outline
							</Icon>
						</IconButton>
					))}
			</MDBox>
		</MDBox>
	)
}

export default PayphoneModalHeader
